import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './required-documents.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Import Swiper components and modules
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Controller } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css'; 
import 'swiper/css/autoplay'; 

// CONTENT extracted from your provided code:
const documents = [
  { id: 1, title: 'Aadhaar Card', description: 'A mandatory government-issued identification document used to verify your identity and residential address during the loan process.' },
  { id: 2, title: 'PAN Card', description: 'An essential document for financial verification and credit assessment, ensuring compliance with RBI regulations during the loan process.' },
  { id: 3, title: 'Income Proof', description: 'Submit your latest salary slips, Form 16, or ITR documents to help us assess your repayment capacity and determine your loan eligibility.' },
  { id: 4, title: 'Bank Statements', description: 'Provide bank statements from the past 6 months for a comprehensive review of your income stability, financial habits, and repayment history.' },
  { id: 5, title: 'Photographs', description: 'Provide recent passport-size photographs as part of your KYC documentation to complete identity verification and maintain official records.' },
];

const RequiredDocuments = () => {
  // Swiper instance storage for controlling it
  const swiperRef = useRef(null);
  
  // State to track the currently active document ID for the tabs
  const [activeIndex, setActiveIndex] = useState(0); 

  // Initialize AOS (Animate On Scroll)
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // Handler for the clickable tabs
  const handleDocClick = (index) => {
    setActiveIndex(index);
    if (swiperRef.current && swiperRef.current.swiper) {
      // Use swiper's method to navigate to the clicked slide
      swiperRef.current.swiper.slideTo(index);
    }
  };

  // Handler for when the swiper auto-slides
  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex);
    // Refresh AOS for content fade-in on slide change
    AOS.refreshHard();
  };

  return (
    <Container className="required-documents-section-compact ">
      <Row className="justify-content-center">
        <Col lg={10}>
          
          {/* Main Header Section */}
          <div className="header-section text-center mb-5" data-aos="fade-down">

            <h2 className="documents-title mb-4">
             Your Loan  <span className="highlight">Journey Made</span> Effortless
            </h2>

            <p className="main-description-compact mx-auto">
              Documents auto-scroll for viewing, or click on any title to focus.
            </p>
          </div>

          {/* === Document Navigator and Detail Display (Compact Layout) === */}
          <Row className="doc-detail-box-container shadow-lg" data-aos="zoom-in">
            
            {/* Left Column: Document Title Navigation (Clickable Tabs) */}
            <Col md={4} className="doc-nav-column p-0">
              <div className="doc-title-list">
                {documents.map((doc, index) => (
                  <div
                    key={doc.id}
                    className={`doc-title-item ${activeIndex === index ? 'active' : ''}`}
                    onClick={() => handleDocClick(index)}
                  >
                    <span className="doc-id-number">{doc.id}</span>
                    {doc.title}
                  </div>
                ))}
              </div>
            </Col>

            {/* Right Column: Dynamic Document Details (Controlled by Swiper) */}
            <Col md={8} className="doc-details-column p-0">
                <Swiper
                    ref={swiperRef}
                    modules={[Autoplay, Controller]}
                    // Autoplay Configuration
                    autoplay={{
                        delay: 4000, // Slides every 4 seconds
                        disableOnInteraction: true, // Stops auto-slide on user click
                        pauseOnMouseEnter: true, // Pauses if mouse hovers over the detail box
                    }}
                    speed={800} // Transition speed
                    spaceBetween={0}
                    slidesPerView={1}
                    // Loop is disabled to keep document order clear (1 to 5)
                    loop={false} 
                    onSlideChange={handleSlideChange} // Update active state on slide change
                    className="document-swiper h-100"
                >
                    {documents.map((doc, index) => (
                        <SwiperSlide key={doc.id} className="document-slide-content p-4">
                            <h3 className="detail-title">{doc.title}</h3>
                            <p className="detail-description">{doc.description}</p>
                            
                            <div className="detail-note mt-4 p-3">
                                <p className="mb-0">
                                    **Requirement Note:** This document must be a clear, digitized copy (PDF or JPEG) for online submission.
                                </p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Col>
          </Row>

        </Col>
      </Row>
      
      {/* Spacer for vertical space efficiency */}
      <div className="py-3"></div> 
    </Container>
  );
};

export default RequiredDocuments;